<template>
  <ul>
    <li
      v-for="(item, i) in items"
      :key="i"
      class="mb-2 last:mb-0 font-medium"
      :class="{ 'list-decimal ml-4': type === 'numbers' }"
    >
      <component
        :is="item.link ? 'a' : 'div'"
        class="flex gap-2"
        :href="item.link"
        :class="twMerge('leading-5 font-medium', listClasses)"
        @click.prevent="item.link && scrollToSection(item.link)"
      >
        <component
          :is="
            camelCase(
              `icon-${summaryListGetters
                .getItemIconClassName(item)
                .replace('bi bi-', '')}`
            )
          "
          v-if="type === 'icons'"
          class="w-5 h-5"
        />

        <div class="flex-1">
          <div>
            {{ summaryListGetters.getItemLabel(item) }}
          </div>
          <div
            v-if="summaryListGetters.getItemDescription(item)"
            class="text-sm leading-5 mt-2 font-normal"
          >
            {{ summaryListGetters.getItemDescription(item) }}
          </div>
        </div>
      </component>
    </li>
  </ul>
</template>

<script lang="ts">
import { twMerge } from 'tailwind-merge'
import camelCase from 'lodash/camelCase'
import {
  IconPeopleFill,
  IconBrushFill,
  IconBarChartFill,
  IconCupFill,
} from '#components'

export default {
  name: 'MagazineSummaryList',
  components: {
    IconPeopleFill,
    IconBrushFill,
    IconBarChartFill,
    IconCupFill,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'icons',
    },
    listClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return { summaryListGetters, camelCase }
  },
  methods: {
    twMerge,
    scrollToSection(link: string) {
      const sectionId = link.slice(1)
      const el = document.getElementById(sectionId)
      if (!el) return

      window.scrollTo({
        // subract 130 to account for navbar
        top: el.offsetTop - 130,
        behavior: 'smooth',
      })
    },
  },
}
</script>
